// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__27S8b","errorLogs":"styles_errorLogs__12872"};